import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { BRAND } from "../lib/constants";

const links = [
  { href: "#fleet", label: "Fleet" },
  { href: "#packages", label: "Packages" },
  { href: "#addons", label: "VIP Add-Ons" },
  { href: "#book", label: "Book" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/90 backdrop-blur-xl border-b border-zinc-900" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-20">
        <a href="/" data-testid="brand-logo-link" className="flex items-center gap-3">
          <img src={BRAND.logo} alt="SFE Black Car" className="h-12 w-12 object-contain" />
          <div className="hidden sm:block">
            <div className="font-display text-base leading-none tracking-tight">SFE BLACK CAR</div>
            <div className="text-[10px] tracking-[0.3em] text-zinc-500 mt-1">
              LUXURY · <span className="text-[#E50914]">SAFETY</span> · EXPERIENCE
            </div>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors"
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href={BRAND.phoneLink}
            data-testid="navbar-phone-cta"
            className="hidden lg:inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-white border border-zinc-800 px-4 py-2.5 hover:bg-white hover:text-black transition-all"
          >
            <Phone className="w-3.5 h-3.5" />
            {BRAND.phone}
          </a>
          <button
            onClick={() => scrollTo("#book")}
            data-testid="navbar-book-now-btn"
            className="bg-[#E50914] hover:bg-[#FF2A2A] text-white text-xs font-bold uppercase tracking-[0.2em] px-5 py-3 transition-all duration-300 hover:shadow-[0_0_24px_rgba(229,9,20,0.5)]"
          >
            Book Now
          </button>
          <button
            className="md:hidden text-white"
            onClick={() => setOpen(!open)}
            data-testid="mobile-menu-toggle"
            aria-label="menu"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-900 bg-black/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <button
                key={l.href}
                onClick={() => scrollTo(l.href)}
                className="text-left text-sm font-semibold uppercase tracking-[0.2em] text-zinc-300 hover:text-white"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </button>
            ))}
            <a
              href={BRAND.phoneLink}
              className="text-sm font-semibold uppercase tracking-[0.2em] text-[#E50914]"
              data-testid="mobile-phone-link"
            >
              {BRAND.phone}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};
